import { ActivatedRoute } from '@angular/router';
import { ModalContainerService, ModalService, UserService, BaseModalContainer } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { VrstaStavki } from './vrsta-stavki';

@Component({
  selector: 'yt-vrsta-stavki',
  templateUrl: './vrsta-stavki.component.html'
})
export class VrstaStavkiComponent extends BaseModalContainer<VrstaStavki> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaStavki>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}